module.exports = __webpack_public_path__ + "img/cooperative0_logo20.0cecb0a4.jpg";